type Props = {};

export function Profile(props: Props) {
  return (
    <div>
      profile
    </div>
  );
};